import {useLocation} from "react-router";
import {AUTH_TYPE} from "../auth-ui/types";

export const useGetAuthType = () => {
    const location = useLocation();

    const authType = location.pathname.includes("signup") ? AUTH_TYPE.SIGNUP : AUTH_TYPE.LOGIN;

    return {authType};
};
